var React = require('react');

function FooterArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M784.845 417.441V111.426L674.185.766H368.171l-.015 123.165 196.318-.007-368.568 368.567-363.748-363.749-86.607 86.606 383.767 383.963h154.167l378.188-378.188-.015 196.31 123.187.008z","fill":"#E6E8E9"}));
}

FooterArrow.defaultProps = {"width":"785","height":"599","fill":"none"};

module.exports = FooterArrow;

FooterArrow.default = FooterArrow;
